export default "__VITE_ASSET__7c6yMD3m__"